import { render, staticRenderFns } from "./nucleic.vue?vue&type=template&id=604ec92b&scoped=true"
import script from "./nucleic.vue?vue&type=script&lang=js"
export * from "./nucleic.vue?vue&type=script&lang=js"
import style0 from "./nucleic.vue?vue&type=style&index=0&id=604ec92b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ec92b",
  null
  
)

export default component.exports